export default __webpack_public_path__ + "static/media/egoeast.50933be6.jpg";